export default "__VITE_ASSET__CQJ8Patc__"